<template>
    <div style="background-color: #fe6100">
        <div style="height:50px; display:flex; background-color: #fe6100">
            <div style="display:grid; place-items: center; width:40px;" ></div>
            <div style="display:grid; place-items: center; flex:1;">
                <img :src="require('@/assets/title.png')" style="height:25px;">
            </div>
            <div style="width:40px;"></div>
        </div>
        <div style="flex:1;overflow:auto; border-top-right-radius: 15px; border-top-left-radius: 15px; background-color: white;">
            <div v-if="step === 0" style="padding:0px 15px;">
                <div style="text-align:center; margin-top:30px;color:#5f6cc3;">나에게 맞는 축구 포지션은?</div>
                <div style="text-align:center;margin-top:10px; font-size:37px; font-weight:900; color:#ff7703;">나의 포지션 찾기</div>
                <div class="first_explain_wrap" style="margin-top:35px;">
                    <div><img :src="require('@/assets/explain_clock.png')" style="width:45px;"></div>
                    <div style="margin-top:10px;font-size:13px;font-weight:bold;">검사는 오래 걸리지 않아요</div>
                </div>
                <div class="first_explain_wrap">
                    <div><img :src="require('@/assets/explain_ball.png')" style="height:45px;"></div>
                    <div style="margin-top:10px;font-size:13px;font-weight:bold;line-height:22px;">테스트 속 질문의 기준은 현재 혹은 과거 운동 경험<br>에서 느낀 본인의 능력치를 토대로 평가해주세요</div>
                </div>
                <div class="first_explain_wrap">
                    <div><img :src="require('@/assets/explain_rounds.png')" style="height:40px;"></div>
                    <div style="margin-top:10px;font-size:13px;font-weight:bold;line-height:22px;">정확한 결과 제공을 위해 가급적이면<br>확실한 정도에 체크해주세요</div>
                </div>
            </div>
            <div style="padding:15px;" v-if="step > 0 && step < sentence_cnt">
                <div style="height:16px; background-color: #ffece1; border-radius:8px;width:100%;position:relative; overflow:hidden;">
                    <div style="position:absolute; left:0px;background-color: #5f6cc3;height: 100%;  border-radius:8px;" :style="{width: parseInt((step ) / (sentence_cnt - 1) * 100) + '%'}"></div>
                </div>
            </div>
            <div v-if="step > 0 && step < sentence_cnt">
                <div style="height:220px; margin-top:50px; display:grid; place-items: center;">
                    <img v-if="step < 43" :src="images[sentence[step].image_index]" style="max-height: 200px; max-width:150px;">
                    <img v-else-if="sentence[step].key === 43" :src="images[12]" style="max-height: 200px; max-width:150px;">
                </div>
                <div style="padding:0px 20px;">
                    <div v-html="sentence[step].text" style="background-color: #ffece1; font-size:18px; font-weight:700;line-height:28px;text-align:center; height: 100px; display:grid;place-items: center;"></div>
                </div>
                <div style="display:flex;justify-items: center; align-items: center; padding:20px 0px;" v-if="step > 0 && step < sentence_cnt - 1">
                    <div style="flex:1;"></div>
                    <template v-if="sentence[step].key === 42">
                        <div class="round_wrap" @click="setScore(5)">
                            <div class="round orange" style="width:46px; height:46px;"></div>
                            <div class="inner_round orange_background" :class="[scores[step] === 5 ? 'active' : '']"></div>
                            <div style="position:absolute; left:5px; top:65px;width:60px; font-weight:bold; font-size:13px; color:#ff7703;">그렇다</div>
                        </div>
                        <div class="round_wrap" @click="setScore(1)">
                            <div class="round blue" style="width:46px; height:46px;"></div>
                            <div class="inner_round blue_background" :class="[scores[step] === 1 ? 'active' : '']"></div>
                            <div style="position:absolute; left:-10px; top:65px;width:60px;  font-weight:bold;font-size:13px; color:#5f6cc3">그렇지 않다</div>
                        </div>
                    </template>
                    <template v-else>
                        <div class="round_wrap" @click="setScore(5)">
                            <div class="round orange" style="width:46px; height:46px;"></div>
                            <div class="inner_round orange_background" :class="[scores[step] === 5 ? 'active' : '']"></div>
                            <div style="position:absolute; left:5px; top:65px;width:60px; font-weight:bold; font-size:13px; color:#ff7703;">그렇다</div>
                        </div>
                        <div class="round_wrap " @click="setScore(4)">
                            <div class="inner_round orange_background" :class="[scores[step] === 4 ? 'active' : '']"></div>
                            <div class="round orange" style="width:36px; height:36px;"></div>
                        </div>
                        <div class="round_wrap" @click="setScore(3)">
                            <div class="inner_round black_background" :class="[scores[step] === 3 ? 'active' : '']"></div>
                            <div class="round" style="width:26px; height:26px; border-color:black;"></div>
                        </div>
                        <div class="round_wrap" @click="setScore(2)">
                            <div class="inner_round blue_background" :class="[scores[step] === 2 ? 'active' : '']"></div>
                            <div class="round blue" style="width:36px; height:36px;"></div>
                        </div>
                        <div class="round_wrap" @click="setScore(1)">
                            <div class="round blue" style="width:46px; height:46px;"></div>
                            <div class="inner_round blue_background" :class="[scores[step] === 1 ? 'active' : '']"></div>
                            <div style="position:absolute; left:-10px; top:65px;width:60px;  font-weight:bold;font-size:13px; color:#5f6cc3">그렇지 않다</div>
                        </div>
                    </template>

                    <div style="flex:1;"></div>
                </div>
                <div style="display:flex;justify-items: center; align-items: center; padding:20px 0px;" v-if="step === sentence_cnt - 1">
                    <div style="flex:1;"></div>
                    <div class="round_wrap" @click="setScore(1)">
                        <div class="round orange" style="width:46px; height:46px;"></div>
                        <div class="inner_round orange_background" :class="[scores[step] === 1 ? 'active' : '']"></div>
                        <div style="position:absolute; left:50%;white-space: nowrap; top:65px; font-weight:bold; font-size:13px; color:#ff7703;transform: translateX(-50%);">왼발</div>
                    </div>

                    <div class="round_wrap" @click="setScore(2)">
                        <div class="inner_round black_background" :class="[scores[step] === 2 ? 'active' : '']"></div>
                        <div class="round" style="width:46px; height:46px; border-color:black;"></div>
                        <div style="position:absolute; left:50%; white-space: nowrap;top:65px; font-weight:bold; font-size:13px; color:black;transform: translateX(-50%);">양발</div>
                    </div>

                    <div class="round_wrap" @click="setScore(3)">
                        <div class="round blue" style="width:46px; height:46px;"></div>
                        <div class="inner_round blue_background" :class="[scores[step] === 3 ? 'active' : '']"></div>
                        <div style="position:absolute; left:50%; white-space: nowrap; top:65px;  font-weight:bold;font-size:13px; color:#5f6cc3; transform: translateX(-50%);">오른발</div>
                    </div>
                    <div style="flex:1;"></div>
                </div>
            </div>
            <div v-if="step === sentence_cnt">
                <div style="padding:100px 0px; display:grid; place-items: center;">
                    <img :src="require('@/assets/myposition_loading.png')" style="width:100px;">
                </div>
                <div style="text-align:center; font-size:20px; font-weight:800; color:#2b2b2b;">열심히 분석중이에요</div>
            </div>
            <div v-if="step === sentence_cnt + 1">
                <div v-for="each, i in positions" :key="i">
                    <div v-if="i !== 0" >
                        <div style="text-align:center; font-size:24px;padding:20px; color:#fe6100;">그외 포지션은?</div>
                        <div style="background-color:#fff4d2; height:15px;"></div>
                    </div>
                    <MyPositionResult :name="''" :position="each.desc" :index="-1">
                        <div v-if="i === 0">
                            <template v-if="isShowSaveForm">
                                <div style="padding:0px 20px;">
                                    <div v-html="'실제 포지션과 일치하시나요?'" style="background-color: #ffece1; font-size:18px; font-weight:700;line-height:28px;text-align:center; height: 100px; display:grid;place-items: center;"></div>
                                </div>
                                <div style="display:flex;justify-items: center; align-items: center; padding:20px 0px;">
                                    <div style="flex:1;"></div>
                                    <div class="round_wrap" @click="() => {match_score = 5}">
                                        <div class="round orange" style="width:46px; height:46px;"></div>
                                        <div class="inner_round orange_background" :class="[match_score === 5 ? 'active' : '']"></div>
                                        <div style="position:absolute; left:5px; top:65px;width:60px; font-weight:bold; font-size:13px; color:#ff7703;">그렇다</div>
                                    </div>
                                    <div class="round_wrap " @click="() => {match_score = 4}">
                                        <div class="inner_round orange_background" :class="[match_score === 4 ? 'active' : '']"></div>
                                        <div class="round orange" style="width:36px; height:36px;"></div>
                                    </div>
                                    <div class="round_wrap" @click="() => {match_score = 3}">
                                        <div class="inner_round black_background" :class="[match_score === 3 ? 'active' : '']"></div>
                                        <div class="round" style="width:26px; height:26px; border-color:black;"></div>
                                    </div>
                                    <div class="round_wrap" @click="() => {match_score = 2}">
                                        <div class="inner_round blue_background" :class="[match_score === 2 ? 'active' : '']"></div>
                                        <div class="round blue" style="width:36px; height:36px;"></div>
                                    </div>
                                    <div class="round_wrap" @click="() => {match_score = 1}">
                                        <div class="round blue" style="width:46px; height:46px;"></div>
                                        <div class="inner_round blue_background" :class="[match_score === 1 ? 'active' : '']"></div>
                                        <div style="position:absolute; left:-10px; top:65px;width:60px;  font-weight:bold;font-size:13px; color:#5f6cc3">그렇지 않다</div>
                                    </div>
                                    <div style="flex:1;"></div>
                                </div>

                                <div style="height:100px; text-align:center; display: grid; place-items: center;">
                                    <div style="border-radius:15px; height:30px; line-height:30px; background-color:#ff7703; display:inline-block; width:150px;color:white; font-weight:bold;" @click="save">확인</div>
                                </div>
                            </template>
                            <template v-else>
                                <div style="padding:0px 20px;">
                                    <div v-html="'제출완료'" style="background-color: #ffece1; font-size:18px; font-weight:700;line-height:28px;text-align:center; height: 100px; display:grid;place-items: center;"></div>
                                </div>
                                <div style="height:30px;"></div>
                            </template>
                        </div>
                    </MyPositionResult>
                </div>
                <!--<div style="text-align:center; background-color: #fff4d2; padding-bottom:20px;" @click="share">-->
                <!--<div style="height:36px; line-height:36px; width:200px; text-align:center; display:inline-block; color:white; font-weight:bold; border-radius:18px; background-color: #fe6100;">공유하기</div>-->
                <!--</div>-->
                <div style="background-color: #fff4d2;color: #907e7e; font-size: 14px;padding: 0px 10px; padding-bottom: 10px;line-height: 16px;">*상기 포지션 결과는 오병이어의 지적재산권법에 의해 보호 받으며 개인적 공유, 게시를 허락합니다. 단, 당사의 허락없는 전체 또는 일부의 상업적 무단도용 및 카피는 법적 제재를 받을 수 있습니다.</div>
                <!--적합한 포지션은 <span><b>{{ getResultPositions() }} </b></span>입니다.-->
            </div>
        </div>
        <div style="background-color: white;padding:15px 0px;" v-if="step !== sentence_cnt + 1">
            <div v-if="step === 0" style="text-align:center;">
                <div style="border-radius:15px; height:30px; line-height:30px; background-color:#ff7703; display:inline-block; width:150px;color:white; font-weight:bold;" @click="next">시작</div>
            </div>
            <div v-if="step > 0 && step < sentence_cnt" style="text-align:center;">
                <div style="border-radius:15px; height:30px; line-height:30px; background-color:#ff7703; display:inline-block; width:150px;color:white; font-weight:bold;" @click="next">{{step === sentence_cnt - 1 ? '결과보기' : '다음'}}</div>
            </div>
        </div>
    </div>

</template>

<script>

    import axios from "axios";
    import MyPositionResult from "../common/MyPositionResult";

    export default {
        name: "SharePositionSurvey",
        components: {MyPositionResult},
        props:{
            completeAction : {
                type : Function,
                default : () => {}
            }
        },
        data(){
            return {
                step : 0,
                sentence : [
                    {key : -1, group_key : -1,text : '', image_index : -1},
                    {key : 1, group_key : 1,text : '나는 날렵하며 달리기가 빠른 편이다.', image_index : 1},
                    {key : 5, group_key : 2,text : '나는 호기심이 많으며,<br>도전을 걸어보거나 모험을 하는것을 즐긴다.', image_index : 2},
                    {key : 9, group_key : 3,text : '나는 내가 하는 행동의 결과를 믿고<br>실패에 대한 두려움이 없는 등.<br>자신감이 높은 편이다.', image_index : 3},
                    {key : 13, group_key : 4,text : '나는 동료를 잘 챙기고,<br>골 양보를 해주는 등,<br>배려심이 있다.', image_index : 4},
                    {key : 17, group_key : 5,text : '나는 경기를 끝까지<br>뛸 수 있을 정도로<br>기초 체력이 좋다.', image_index : 5},
                    {key : 21, group_key : 6,text : '나는 공에 대한 감각이 좋으며,<br>볼 컨트롤, 드리블 능력이<br>좋은 편이다.', image_index : 6},
                    {key : 25, group_key : 7,text : '나는 셈세한 편이며, 패스와 크로스,<br>킥 등 볼 전달 능력이 좋은 편이다.', image_index : 7},
                    {key : 29, group_key : 8,text : '나는 시야가 넓은 편이며,<br>빈공간이나 기회를 잘 옅볼 수 있다.', image_index : 8},
                    {key : 33, group_key : 9,text : '나는 문제상황 혹은 기회를<br>잘 파악할 수 있으며,<br>경기의 흐름을 잘 읽는다.', image_index : 9},
                    {key : 37, group_key : 10,text : '나는 내가 맡은 역할에 대해<br>애정과 책임감을 가지고 임하는 편이며,<br>내 포지션의 역할을 놓치지 않고 수행한다.', image_index : 10},
                    {key : 40, group_key : 11,text : '나는 내 주변에서 혹은 내 팀에서<br>키가 큰 편에 속한다.', image_index : 11},

                    {key : 2, group_key : 1,text : '나는 현재 우리팀에서 빠른편이다.', image_index : 1},
                    {key : 6, group_key : 2,text : '나는 성공확률 (패스, 드리블, 슛)이<br>적더라도 도전을 한다.', image_index : 2},
                    {key : 10, group_key : 3,text : '나는 드리블을 할때 수비에게<br>두려움을 느낀적이 없다.', image_index : 3},
                    {key : 14, group_key : 4,text : '나는 힘들어 하는 팀원을 위해<br>팀원의 수비까지 해줄수 있다.', image_index : 4},
                    {key : 18, group_key : 5,text : '나는 내가 속한 그룹에서<br>오래달리기를 하면<br>1등할 자신이 있다.', image_index : 5},
                    {key : 22, group_key : 6,text : '나는 나에게 들어온 볼은<br>뺏기지 않는다.', image_index : 6},
                    {key : 26, group_key : 7,text : '나는 스피드있게 움직이는 순간에도<br>패스, 킥, 슛을 원하는곳으로 보낼수 있다.', image_index : 7},
                    {key : 30, group_key : 8,text : '나는 정면을 바라봐도 좌,우에<br>움직임들이 눈에 들어온다.', image_index : 8},
                    {key : 34, group_key : 9,text : '나는 체력적으로 너무 힘든 순간에도<br>팀이 어떻게 하면 이길수 있는지 생각이 된다. ', image_index : 9},
                    {key : 38, group_key : 10,text : '나는 나 때문에 생긴 팀에<br>실점을 메꾸기 위해 최선을 다한다.', image_index : 10},
                    {key : 41, group_key : 11,text : '나는 수비와 공중볼 헤딩경합에서<br>점프를 안해도 이긴다.', image_index : 11},

                    {key : 3, group_key : 1,text : '나는 속해있는 그룹(학교, 회사포함)에서<br>빠른편이다.', image_index : 1},
                    {key : 7, group_key : 2,text : '나는 코너킥으로 슛에<br>도전할 생각이 있다.', image_index : 2},
                    {key : 11, group_key : 3,text : '나는 슛을 할때 골이<br>들어간다고 생각한다', image_index : 3},
                    {key : 15, group_key : 4,text : '나는 포지션이 겹치는 친구가<br>바꿔달라고 하면 바꿔준다.', image_index : 4},
                    {key : 19, group_key : 5,text : '나는 경기가 끝나고<br>힘들지가 않다.', image_index : 5},
                    {key : 23, group_key : 6,text : '나는 예측못한 수비가 갑자기 와도<br>볼을 뺏기지 않는다.', image_index : 6},
                    {key : 27, group_key : 7,text : '나는 팀 동료들이 패스,킥력이<br>좋다는 소리를 많이 듣는다.', image_index : 7},
                    {key : 31, group_key : 8,text : '나는 평소의 팀원들이<br>시야가 좋다는 이야기를 자주 듣는다. ', image_index : 8},
                    {key : 35, group_key : 9,text : '나는 축구경기를 관전할때도<br>팀들의 경기흐름이 어떻게 가고 있는지 예측이되고 승부도 맞출때가 많다.', image_index : 9},
                    {key : 39, group_key : 10,text : '나는 평소의 책임감이 있다는<br>이야기를 많이 듣는다. ', image_index : 10},

                    {key : 4, group_key : 1,text : '나는 앞서있는 사람도<br>따라잡을 자신이 있다.', image_index : 1},
                    {key : 8, group_key : 2,text : '나는 1대1 상황에서 패스보다는<br>돌파를 하는게 더 좋다.', image_index : 2},
                    {key : 12, group_key : 3,text : '나에게 패스오기만 한다면<br>골을 넣을수 있다고 생각한다.', image_index : 3},
                    {key : 16, group_key : 4,text : '나는 골넣는것 보다<br>어시스트를 더 선호한다.', image_index : 4},
                    {key : 20, group_key : 5,text : '나는 평소의 체력이 좋다는<br>소리를 많이 듣는다.', image_index : 5},
                    {key : 24, group_key : 6,text : '나는 1대1은 무조건 이긴다고 생각한다.', image_index : 6},
                    {key : 28, group_key : 7,text : '프리킥, 코너킥은 내가 전담키커다.', image_index : 7},
                    {key : 32, group_key : 8,text : '나는 패스를 멀리하는걸<br>선호하고 잘한다는 소리를 듣는다.', image_index : 8},
                    {key : 36, group_key : 9,text : '나는 팀원들이 경기흐름을<br>잘본다고 많이들 이야기 한다.', image_index : 9},
                    {key : 42, group_key : 11,text : '나는 내가 속해있는 그룹(학교, 회사, 팀..)<br>에서 키가 1~2으로 크다. (Yes, no)', image_index : 11},
                    {key : 43, group_key : 12,text : '내가 주로 사용하는 발은?', image_index : 11},


                    // '나는 날렵하며 달리기가 빠른 편이다.',
                    // '나는 호기심이 많으며,<br>도전을 걸어보거나 모험을 하는 것을 즐긴다.',
                    // '나는 내가 하는 행동의 결과를 믿고,<br>실패에 대한 두려움이 없는 등,<br>자신감이 높은 편이다.',
                    // '나는 경기를 끝까지 뛸 수 있을 정도로<br>기초 체력이 좋다.',
                    // '나는 동료를 잘 챙기고,<br>골 양보를 해주는 등<br>배려심이 있다.',
                    // '나는 공에 대한 감각이 좋으며,<br>볼 컨트롤, 드리블 능력이 좋은 편이다.',
                    // '나는 섬세한 편이며,<br>패스와 크로스, 킥 등<br>볼 전달 능력이 좋은 편이다.',
                    // '나는 시야가 넓은 편이며,<br>빈공간이나 기회를 잘 옅볼 수 있다.',
                    // '나는 문제상황 혹은 기회를<br>잘 파악할 수 있으며,<br>경기의 흐름을 잘 읽는다.',
                    // '나는 내가 맡은 역할에 대해<br>애정과 책임감을 가지고 임하는 편이며,<br>내 포지션의 역할을 놓치지 않고 수행한다.',
                    // '나는 내 주변에서<br>혹은 내 팀에서 키가 큰 편에 속한다.',
                    // '내가 주로 사용하는 발은?',
                ],
                images : [
                    '',
                ],
                scores : [
                    0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                    0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                    0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                    0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
                    0, 0, 0, 0, 0, 0, 0, 0, 0,
                ],
                positions : [
                    // {desc : "CB", position : "CB"},
                    // {desc : "SS", position : "SS"},
                ],
                sentence_cnt : 0,
                match_score : 0,
                isShowSaveForm : true,
            }
        },
        methods : {
            next(){
                if(this.step > 0 && this.step < this.sentence_cnt && !this.validate()) {
                    this.$GlobalStore.showAlert('항목을 선택해주세요.');
                    return;
                }

                this.step++;

                if(this.step === this.sentence_cnt) {
                    this.submit();
                }
            },
            setScore(score){
                this.$set(this.scores, this.step, score);
            },
            validate(){
                if(this.scores[this.step] === 0) return false;
                return true;
            },
            async submit(){
                // 1 하(그렇지않다) 2 중하 3 중 4 중상 5 상(그렇다)
                // const temp_score = this.scores.splice(1, this.sentence_cnt - 1); //1문항부터 12개. 12번째 1 왼발, 2 양발 3 오른발

                let score_infos = [];

                for(let i = 1; i < this.sentence_cnt; i++){
                    score_infos.push({
                        key : this.sentence[i].key,
                        group_key : this.sentence[i].group_key,
                        score : this.scores[i],
                    });
                }

                // console.log(score_infos);

                // for(let i = 1; i < this.sentence_cnt; i++){
                //     scores[this.sentence[i].index] = this.scores[i];
                // }


                const parameters = {};
                parameters.score_infos = JSON.stringify(score_infos);
                const res = await axios.post('/api/share/position/survey', parameters);
                // console.log(this.positions);
                this.positions = res.data.positions;
                // let savedPosition = '';
                // if(this.positions.length > 0) savedPosition = this.positions[0].desc;
                // this.completeAction(savedPosition);
                this.next();
            },
            getResultPositions() {
                let result = "";
                for(let k in this.positions) {
                    const item = this.positions[k];
                    result += `${item.position} (${item.desc}), `
                }
                return result;
            },
            async save(){
                if(this.match_score === 0){
                    this.$GlobalStore.showAlert('실제 포지션과 일치정도를 선택해주세요.');
                    return;
                }

                let search_params = new URLSearchParams(location.search);
                let team = '';

                if(!search_params.has('team')){
                    team = prompt('team을 입력해주세요.');
                    if(!team){
                        return;
                    }
                }else {
                    team = search_params.get('team');
                }


                let score_infos = [];

                for(let i = 1; i < this.sentence_cnt; i++){
                    score_infos.push({
                        key : this.sentence[i].key,
                        group_key : this.sentence[i].group_key,
                        score : this.scores[i],
                    });
                }

                const parameters = {};
                parameters.score_infos = JSON.stringify(score_infos);
                parameters.match_score = this.match_score;
                parameters.position = this.positions[0].desc;
                parameters.position2 = this.positions[1].desc;
                parameters.team = team;
                const res = await axios.post('/api/share/position/survey/save', parameters);
                this.isShowSaveForm = false;
                if(res.data.code === -1){
                    this.$GlobalStore.showAlert(res.data.msg);
                }
            }
        },
        created(){
            this.save = this.$Once(this.save);

            for(let i = 1; i <= 12; i++){
                let number = '';
                if(i < 10){
                    number += '0';
                }
                number += '' + i;
                this.images.push(require('@/assets/myposition_question' + number + '.png'))
            }

            // //테스트 용 코드
            // this.step = 42;
            // this.scores = [
            //     0,
            //     5, 4, 3, 2, 1, 5, 4, 3, 2, 1,
            //     5, 4, 3, 2, 1, 5, 4, 3, 2, 1,
            //     5, 4, 3, 2, 1, 5, 4, 3, 2, 1,
            //     5, 4, 3, 2, 1, 5, 4, 3, 2, 1,
            //     5, 5, 0, 0, 0, 0,
            // ]

            this.sentence_cnt = this.sentence.length;

        }
    }
</script>

<style scoped>
    .first_explain_wrap{
        padding: 15px 10px 20px 10px;
        text-align:center;
        background-color: #ffece1;
        border-radius:5px;
    }
    .first_explain_wrap + .first_explain_wrap{margin-top:10px;}
    .round_wrap{position:relative;font-size:0px;}
    .round{border-radius:50%; border:1px solid black;}
    .round_wrap + .round_wrap{margin-left:30px;}
    .round.orange{border-color:#ff7703}
    .round.blue{border-color:#5f6cc3}
    .inner_round{width:calc(100% - 6px); height:calc(100% - 6px); display:none; background-color:blue; position:absolute; left:50%; top:50%;transform: translate(-50%, -50%); border-radius:50%; }
    .orange_background{background-color: #ff7703;}
    .blue_background{background-color:#5f6cc3;}
    .inner_round.active{display:block;}
    .black_background{background-color: black;}

</style>
